import store from '@/store';

export class SdkCampaignApi {
  static async getId(): Promise<number | undefined> {
    await store.getters['campaign/readyPromise'];
    const campaignState = store.getters['campaign/state'];
    return campaignState.config?.campaignId;
  }

  static async getName(): Promise<string> {
    await store.getters['campaign/readyPromise'];
    const campaignState = store.getters['campaign/state'];
    return campaignState.name;
  }

  static async getType(): Promise<string | undefined> {
    await store.getters['campaign/readyPromise'];
    const campaignState = store.getters['campaign/state'];
    return campaignState.config?.gameType;
  }
}
